/* eslint react/button-has-type: "off" */

import React from 'react';
import styled from 'styled-components';

import { Lavendar, Purple, White } from '../colors';

const Button = styled(({ className, icon, children, type, ...rest }) => (
  <button type={type || 'button'} className={className} {...rest}>
    {icon && icon}
    {children}
  </button>
))`
  display: inline-flex;
  align-items: center;

  padding: 8px 14px;
  border: none;
  border-radius: 5px;

  color: ${White};
  background-color: ${Purple};
  box-shadow: 0px 4px 7px -4px rgba(148, 0, 211, 0.6);

  transition: all 0.3s;

  svg {
    fill: white;
    margin-right: 8px;
  }

  :disabled {
    background-color: ${Lavendar};
    box-shadow: none;
  }

  :hover:enabled {
    box-shadow: 0px 6px 9px 0px rgba(148, 0, 211, 0.6);
  }

  a {
    color: ${White};
  }

  a:hover {
    text-decoration: none;
  }
`;

export default Button;
